module.exports = __webpack_public_path__ + "video/2600_KMSAT45_2022_YRConclusion.c106b5cc.vtt";